import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    FaTicketAlt,
    FaBox,
    FaCartPlus,
    FaChartLine,
    FaChevronDown,
    FaTools,
    FaArrowRight,
    FaHardHat
} from 'react-icons/fa';
import styles from './Tecnicomto.module.css';

const TecnicoMto = () => {
    const [equiposOpen, setEquiposOpen] = useState(false);
    const [ticketsOpen, setTicketsOpen] = useState(true); // Default open for better UX
    const [consumosOpen, setConsumosOpen] = useState(false);
    const [indicadoresOpen, setIndicadoresOpen] = useState(false);

    const toggleEquipos = () => {
        setEquiposOpen(!equiposOpen);
        setTicketsOpen(false);
        setConsumosOpen(false);
        setIndicadoresOpen(false);
    };

    const toggleConsumo = () => {
        setConsumosOpen(!consumosOpen);
        setEquiposOpen(false);
        setTicketsOpen(false);
        setIndicadoresOpen(false);
    };

    const toggleTickets = () => {
        setTicketsOpen(!ticketsOpen);
        setEquiposOpen(false);
        setConsumosOpen(false);
        setIndicadoresOpen(false);
    };

    const toggleIndicadores = () => {
        setIndicadoresOpen(!indicadoresOpen);
        setEquiposOpen(false);
        setTicketsOpen(false);
        setConsumosOpen(false);
    };

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h2 className={styles.title}>
                    <FaHardHat style={{ marginRight: '15px' }} />
                    Módulo Técnico Mantenimiento
                </h2>
                <p className={styles.subtitle}>Panel de control para la gestión de infraestructura y mantenimiento físico.</p>
            </header>

            <div className={styles.menuGrid}>
                {/* Gestión de Tickets */}
                <div className={`${styles.sectionCard} ${styles.tickets} ${ticketsOpen ? styles.isOpen : ''}`}>
                    <button className={styles.sectionHeader} onClick={toggleTickets}>
                        <div className={styles.headerLeft}>
                            <div className={styles.iconWrapper}>
                                <FaTicketAlt />
                            </div>
                            <span className={styles.sectionTitle}>Gestión de Tickets</span>
                        </div>
                        <FaChevronDown className={styles.chevron} />
                    </button>
                    <div className={styles.sectionContent}>
                        <div className={styles.linkList}>
                            <Link to="/asigtecmto" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Asignar técnico
                            </Link>
                            <Link to="/allhistorialmto" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Historial de servicios
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Equipos (Infraestructura) */}
                <div className={`${styles.sectionCard} ${styles.equipos} ${equiposOpen ? styles.isOpen : ''}`}>
                    <button className={styles.sectionHeader} onClick={toggleEquipos}>
                        <div className={styles.headerLeft}>
                            <div className={styles.iconWrapper}>
                                <FaBox />
                            </div>
                            <span className={styles.sectionTitle}>Equipos e Infraestructura</span>
                        </div>
                        <FaChevronDown className={styles.chevron} />
                    </button>
                    <div className={styles.sectionContent}>
                        <div className={styles.linkList}>
                            <Link  className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Crear Equipo
                            </Link>
                            <Link  className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Dar De Baja
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Consumos */}
                <div className={`${styles.sectionCard} ${styles.consumos} ${consumosOpen ? styles.isOpen : ''}`}>
                    <button className={styles.sectionHeader} onClick={toggleConsumo}>
                        <div className={styles.headerLeft}>
                            <div className={styles.iconWrapper}>
                                <FaCartPlus />
                            </div>
                            <span className={styles.sectionTitle}>Insumos</span>
                        </div>
                        <FaChevronDown className={styles.chevron} />
                    </button>
                    <div className={styles.sectionContent}>
                        <div className={styles.linkList}>
                            <Link  className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Consumo de insumos
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Indicadores */}
                <div className={`${styles.sectionCard} ${styles.indicadores} ${indicadoresOpen ? styles.isOpen : ''}`}>
                    <button className={styles.sectionHeader} onClick={toggleIndicadores}>
                        <div className={styles.headerLeft}>
                            <div className={styles.iconWrapper}>
                                <FaChartLine />
                            </div>
                            <span className={styles.sectionTitle}>Rendimiento</span>
                        </div>
                        <FaChevronDown className={styles.chevron} />
                    </button>
                    <div className={styles.sectionContent}>
                        <div className={styles.linkList}>
                            <Link to="/indicagestmto" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Indicadores de gestión
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TecnicoMto;
